import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import tcModel from '@module/consent-manager/tc-model';
import I18n from '@module/i18n';

import { Consent, alignments } from './consent';
import { initVendorListState } from './helper';
import { VendorDescription } from './descriptions';

export function VendorList({ consentLanguage }) {
  const [preferences, setPreferences] = useState(
    initVendorListState(consentLanguage)
  );

  useEffect(() => {
    setPreferences(initVendorListState(consentLanguage));
  }, [consentLanguage]);

  const handleVendorConsent = (id, checked) => {
    const newPref = { ...preferences };
    newPref[id].purposeConsent = checked;
    setPreferences(newPref);

    if (checked) {
      tcModel.vendorConsents.set(id);
      return;
    }

    tcModel.vendorConsents.unset(id);
  };

  const toggleDescription = (id) => {
    const newPref = { ...preferences };
    newPref[id].descriptionVisible = !newPref[id].descriptionVisible;
    setPreferences(newPref);
  };

  const sortedPreferences = Object.values(preferences).sort(function (a, b) {
    var nameA = a.name.toUpperCase(); // ignore upper and lowercase
    var nameB = b.name.toUpperCase(); // ignore upper and lowercase

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  });

  return sortedPreferences.map(
    ({
      id,
      name,
      purposeConsent,
      descriptionVisible,
      purposeDescriptions,
      featureDescriptions,
      policyUrl,
    }) => (
      <Consent
        key={id}
        onToggle={() => toggleDescription(id)}
        consentName={name}
        className="consent"
        descriptionVisible={descriptionVisible}
        align={alignments.TOP_RIGHT}
        consentSwitchesProps={[
          {
            name: `vendor-consent-${id}`,
            label: I18n.t('transfer.consent-manager.switch-by-partners'),
            checked: purposeConsent,
            onChange: (checked) => handleVendorConsent(id, checked),
          },
        ]}
      >
        <VendorDescription
          purposeDescriptions={purposeDescriptions}
          featureDescriptions={featureDescriptions}
          policyUrl={policyUrl}
        />
      </Consent>
    )
  );
}

VendorList.propTypes = {
  consentLanguage: PropTypes.object,
};
